var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYieldFarming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3318 10.1H13.0785H12.6982L12.5368 10.4491L8.0627 20.1369L7.66455 21H8.60553H12.4675H12.8513L13.0115 20.6461L14.6484 17.0228L15.9755 20.6073L16.1202 21H16.5339H20.8048H21.7446L21.3452 20.1369L16.8735 10.4491L16.7109 10.1H16.3318Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.815 12.6154H4.25691H3.95795L3.83103 12.8839L0.313063 20.3361L0 21H0.739882H3.7765H4.07828L4.20426 20.7277L5.4913 17.9406L6.53484 20.6979L6.6486 21H6.97388H10.332H11.071L10.757 20.3361L7.24088 12.8839L7.11302 12.6154H6.815Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4648 8.11816H13.5367H13.0776L12.8827 8.53075L7.48072 19.98L7 21H8.13612H12.799H13.2624L13.4558 20.5817L15.4321 16.2997L17.0346 20.5359L17.2092 21H17.7087H22.8653H24L23.5178 19.98L18.1187 8.53075L17.9224 8.11816H17.4648Z",
    fill: "#71CEF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1041 0L18.8627 1.20081L19.1374 2.1536L21.0495 1.61185L18.75 4.64994H11.7427L9.24204 8.11814H2.21694L0.571289 10.836L1.42878 11.3458L2.78204 9.10905H9.75734L12.256 5.64085H19.25L21.7584 2.32674L21.5051 4.08442L22.495 4.22455L23.1041 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYieldFarming);
export default __webpack_public_path__ + "static/media/yield-farming.0fae2b043ddf9af899e3f9a0ad6fe1ed.svg";
export { ForwardRef as ReactComponent };